import { cn, Notification, Text } from '@pzh-ui/components'
import { Lock, LockOpen } from '@pzh-ui/icons'
import { useParams } from 'react-router-dom'

import ToggleSwitch from '@/components/ToggleSwitch'
import useModule from '@/hooks/useModule'
import usePermissions from '@/hooks/usePermissions'
import useModalStore from '@/store/modalStore'

const ModuleLock = () => {
    const { moduleId } = useParams()
    const { canEditModule } = usePermissions()

    const setActiveModal = useModalStore(state => state.setActiveModal)

    const { useEditModule, isModuleManager, isLocked, isClosed, canComplete } =
        useModule()
    const { mutate } = useEditModule('moduleUnlocked')

    if (!canEditModule && !isModuleManager && isLocked && !isClosed) {
        return <LockedNotification />
    } else if (!canEditModule && !isModuleManager && (!isLocked || isClosed)) {
        return null
    }

    return (
        <div className="bg-pzh-gray-100 mt-6 flex items-center px-4 py-2">
            {isLocked ? <Lock size={24} /> : <LockOpen size={24} />}
            <Text className="ml-3">
                {isClosed
                    ? 'Onderdelen in deze module kunnen niet meer worden bewerkt'
                    : isLocked
                      ? canComplete
                          ? 'Onderdelen in deze module kunnen niet meer worden bewerkt'
                          : 'Onderdelen in deze module kunnen tijdelijk niet bewerkt worden'
                      : 'Onderdelen in deze module mogen worden bewerkt door de behandelend ambtenaren'}
            </Text>
            {!canComplete && !isClosed && (
                <div className="ml-auto">
                    <ToggleSwitch
                        title={
                            isLocked
                                ? 'Module ontgrendelen'
                                : 'Module vergrendelen'
                        }
                        checked={!isLocked}
                        onClick={checked => {
                            if (!checked) {
                                setActiveModal('moduleLock')
                            } else {
                                mutate({
                                    moduleId: parseInt(moduleId!),
                                    data: {
                                        Temporary_Locked: false,
                                    },
                                })
                            }
                        }}
                    />
                </div>
            )}
        </div>
    )
}

interface LockedNotificationProps {
    isDetail?: boolean
}

export const LockedNotification = ({ isDetail }: LockedNotificationProps) => (
    <Notification
        variant="warning"
        title="De module is op dit moment vergrendeld, er kunnen geen wijzigingen worden aangebracht."
        className={cn('w-full', { 'mt-6': !isDetail })}
    />
)

export default ModuleLock
